<template>
    <div>
        <v-container fluid id="home" class="fill-height">
            <v-row justify-center align="center" justify="center">
                <v-col cols="12" sm="12" md="12">
                    <v-card class="pa-12 mx-auto mt-8" id="login" max-width="500px" elevation="7" v-if="verify==='true'">
                        <v-card-text class="mt-n12 text-center">
                            <v-avatar color="green" size="62" class="mt-n12">
                                <v-icon dark large>mdi-check-bold</v-icon>
                            </v-avatar>
                        </v-card-text>
                        <h3 class="text-center" style="color:green">CONGRATULATIONS</h3>
                        <v-card-text>
                            Your account has been verified successfully! Click 'Ok' To Continue
                        </v-card-text>
                        <v-card-actions>
                            <div class="mx-auto mt-12">
                            <v-btn large dark color="green" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" router-link to="/login">
                                Okay
                            <v-icon right>mdi-login</v-icon>
                            </v-btn>
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="pa-12 mx-auto mt-8" id="login" max-width="500px" elevation="7" v-if="verify==='false'">
                        <v-card-text class="mt-n12">
                            <v-avatar color="red" size="62" class="mt-n12">
                                <v-icon dark large>mdi-close</v-icon>
                            </v-avatar>
                        </v-card-text>
                        <h3 class="text-center" style="color:#1a00d4">Unverified</h3>
                        <v-card-text>
                            Your Account Could Not Be Verified, Please Try Again Later. Click 'Ok' To Continue
                        </v-card-text>
                        <v-card-actions>
                            <div class="mx-auto mt-12">
                            <v-btn large dark color="1a00d4" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" router-link to="/home">
                                Okay
                            <v-icon right>mdi-login</v-icon>
                            </v-btn>
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="pa-12 mx-auto mt-8" id="login" max-width="500px" elevation="7" v-if="verify==='verified'">
                        <v-card-text class="mt-n12 text-center">
                            <v-avatar color="#333333" size="62" class="mt-n12">
                                <v-icon dark large>mdi-shield-alert</v-icon>
                            </v-avatar>
                        </v-card-text>
                        <h3 class="text-center" style="color:#333333">Account Verified</h3>
                        <v-card-text>
                            Your Account Has Already Been Verified. Click 'Ok' To Continue
                        </v-card-text>
                        <v-card-actions>
                            <div class="mx-auto mt-12">
                            <v-btn large dark color="#333333" :loading="loading" class="text-none ml-2 font-weight-bold title mt-n9" router-link to="/login">
                                Okay
                            <v-icon right>mdi-login</v-icon>
                            </v-btn>
                            </div>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>  
    </div>
</template>
<script>
export default {
    data(){
        return{
            verify:''
        }
        
    },
    created(){
        this.$store.dispatch("verifyUser",{
          "username":this.$route.query.username,
          "code":this.$route.query.code
        })
        .then((success)=>{
            console.log(success)
            this.verify='true'
        })
        .catch((error)=>{
            if(error.response.status===409){
                this.verify= 'verified'
            }else{
                this.verify = 'false'
            }       
        })
    }
}
</script>
<style scoped>
    #login{
        border-radius: 5px;
    }
</style>